<template>
	<div>
		<agency-contest-beneficiaries-table/>
		<agency-d-a-c-codes/>
		<agency-contest-type-table/>
		<agency-contest-paragraphs-table/>
	</div>
</template>

<script>
	import AgencyContestBeneficiariesTable from "./AgencyContestBeneficiariesTable";
	import AgencyDACCodes from "./AgencyContestDACCodes";
	import AgencyContestTypeTable from "./AgencyContestTypeTable";
	import AgencyContestParagraphsTable from "./AgencyContestParagraphsTable";

	export default {
		name: "AgencyContantFieldsView",
		components: {
			AgencyContestParagraphsTable,
			AgencyContestTypeTable,
			AgencyDACCodes,
			AgencyContestBeneficiariesTable
		}
	};
</script>

<style scoped>

</style>
